export default "__VITE_ASSET__Cp$h1bMW__"